export const LOAD_FLAVORS: Record<string, string> = {
  "unwanted-staff": "増えたのは人数だけだった。PJ限定の窓際2枚を捨て札に加える。",
  "pending-tasks": "未処理の依頼が積み上がった。PJ限定の「差し戻し対応」2枚を捨て札に加える。",
  "draw-restriction": "情報の流れが細くなった。次ラウンドは施策1回につき合計1枚までしか引けない。通常の手札補充は対象外。",
  interrupt: "今日じゃなくていい仕事が今日来た。",
  "weekend-work": "カレンダーは休日。会社は平日。",
  "incident-response": "動くはずのところが動かない。",
  "update-eve": "震える手でエナジードリンクを飲み干す。",
  "night-release": "夜が明けても、作業は終わらなかった。",
  "service-outage": "画面が落ちた。問い合わせが先に来た。",
  "system-outage": "必要な環境が、一部使えない。",
  "critical-system-outage": "仕事を始めるためのものが、ほとんどそろわない。",
  "rework-ticket": "どうやら作業に不備があったようだ。",
  sendback: "大量のやり直しが発生した。",
  rebuild: "仕様通り作ったはずなのに。",
  "req-change": "本当に同じプロジェクトなのか。",
  scrap: "ここまでの決定は、なかったことになった。",
  "expectation-gap": "お客さんと想定がずれていた。",
  "client-review": "あまりにも妥当な指摘を受けた。",
  "scope-creep": "抵抗したが追加を阻止できなかった。",
  "prod-incident": "最悪の事態が発生した。",
};
